const draw = function (Vue) {
    Vue.directive('draw', {
        bind: function (el, binding) {
            const headDom = el.querySelector('.el-drawer__header')
            const beforeDom = el.querySelector('.el-drawer__close-btn')
                //在关闭按钮之前插入全屏按钮
            const i = document.createElement('i')
            i.style.cssText += `margin-left:20px;font-size:18px;margin-right:7px;float: right;cursor: pointer;`
            i.classList.add("fullScreen")
            i.classList.add("el-icon-quanping")
            headDom.insertBefore(i, beforeDom)
        },
        inserted: function (el, binding, vnode) {
            // 聚焦元素
            el.childNodes[0].removeAttribute("tabindex")
                //设置抽屉元素样式
            el.style.cssText += `left:${binding.value}px;top:45%;transition:top ease-in-out 0.3s`
            const fullScreenDom = document.querySelector('.fullScreen')
            el.onclick = function (e) {
                if (e.target.className.includes('el-dialog__close')) {
                    //还原默认样式
                    el.style.top = "45%"
                    el.style.display = 'none'
                    fullScreenDom.classList.remove("el-icon-fanhuizhengchangpingmu");
                    fullScreenDom.classList.add("el-icon-quanping")
                        //触发事件
                    vnode.child.$emit('fullscreen', false)
                }
                if (e.target.className === 'fullScreen el-icon-quanping') {
                    el.style.top = "110px"
                    e.target.style.cssText += "font-size:28px;"
                    e.target.classList.remove("el-icon-quanping");
                    e.target.classList.add("el-icon-fanhuizhengchangpingmu")
                    vnode.child.$emit('fullscreen', true)
                } else if (e.target.className === 'fullScreen el-icon-fanhuizhengchangpingmu') {
                    el.style.top = "45%"
                    e.target.style.cssText += "font-size:18px;"
                    e.target.classList.remove("el-icon-fanhuizhengchangpingmu");
                    e.target.classList.add("el-icon-quanping")
                    vnode.child.$emit('fullscreen', false)
                }
            }
            window.addEventListener('toggleMenuTab', () => {
                el.style.transition = "none 0s"
                el.style.top = "45%"
                fullScreenDom.classList.remove("el-icon-fanhuizhengchangpingmu");
                fullScreenDom.classList.add("el-icon-quanping")
                vnode.child.$emit('close')
            })
        },
        update: function (el, binding) {
            el.style.left = binding.value + 'px'
        },
    })
}

export default draw